
import { defineComponent,ref } from 'vue'
import { onBeforeRouteUpdate,useRouter,useRoute } from 'vue-router'

import TopBar from '@/components/TopBar.vue'
export default defineComponent({
    components:{
        TopBar
    },
    setup() {
        const router = useRouter()
        const route = useRoute()

        const viewIndex = ref(0)

        const caseView = (value:string) => {
            switch (value) {
                case '/TaskView':
                    viewIndex.value = 0
                    break;
                case '/UploadView':
                    viewIndex.value = 1
                    break;
                case '/BankView':
                    viewIndex.value = 2
                    break;
                case '/AgreeView':
                    viewIndex.value = 3
                    break;
                default:
                    break;
            }
            return viewIndex
        }
        caseView(route.path)
        onBeforeRouteUpdate((to) => {
            caseView(to.path)
        })
        const changeView = (path:string) => {
            router.push({path:path})
        }
        return {
            viewIndex,
            changeView
        }
    },
})
